module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-2021-5.50fd79a1.jpg";